<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Permohonan Program Khas Pemeriksaan Kebuntingan (PD)">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
              <!-- <z-select style="margin:5px; " v-model="pencarian.lkp_tujuan_id" :items="lkp_tujuan" label="Tujuan PD" />
              <w-input style="margin:5px; " v-model="pencarian.no_permohonan" label="No Permohonan" /> -->
            </w-flex>
          </w-form>
          <!-- <w-flex justify-end class="mt2">
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button class="mr2" v-on="on" v-on:click="resetPencarian()" bg-color="warning"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-redo</w-icon>
                 </w-button>
                 </template>
                SET SEMULA
               </w-tooltip>
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button class="mr2" v-on="on" bg-color="primary" @click="$refs.frm.validate()"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-search</w-icon>
                 </w-button>
                 </template>
                CARI
               </w-tooltip>
          </w-flex> -->
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Program Khas Pemeriksaan Kebuntingan (PD)" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
           <!--  <template #button v-if="$zutil.anyRole(['4'])">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button dark class="green--bg ml1" v-on="on" :route="$route('art.program_khas.form',0)" ><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-plus</w-icon>
                 </w-button>
                 </template>
                TAMBAH
               </w-tooltip>
            </template> -->

            <template #button >
                <w-button dark class="green--bg ml1" v-on="on" :route="$route('program.program_khas.form',0)"  v-if="$zutil.anyRole(['4'])">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </w-button>
            </template>

            <template #item-cell.jumlah_bunting="{ item }">
              {{ item.jumlah_bunting === null ? 0 : item.jumlah_bunting }}
            </template>

  		    <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
              <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <w-tooltip top color="white" bg-color="black">
                <template #activator="{ on }">
                   <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19" :route="$route('program.program_khas.form',item.id)" class="be fs-2"><div style="width: 8px"></div>
                      <w-icon md class="mr2">fal fa-pencil</w-icon>
                   </w-button>
                </template>
                Kemaskini
             </w-tooltip>
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('program.program_khas.papar', item.id)" v-on="on" v-if="item.lkp_status_id ==18" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar
                </w-tooltip>
            </w-flex>
          </template>
  		  </z-table>
      </div>
      
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'program.program_khas',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Program Khas', route: '/program' },
        { label: 'PD', route: '/program/pd' },
      ],
      form : this.d_form,

      pencarian: {
         premis_id: '',
         lkp_art_id: '',
         lkp_status_id: '',
         lkp_tujuan_id: '',
         no_permohonan: '',

      },
      premis: [],
      lkp_art: [],
      lkp_status :[],
      lkp_tujuan :[],
      juruteknik_list: [],
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      
      
    }
  },
  methods: {
   DTindakan(item, tindakan){
      //tindakan '3' untuk tukar juruteknik
      //tindakan '2' untuk Padam
       this.dialog_form = {
           id : item.id,
           juruteknik_id : item.juruteknik_id,
           catatan : null,
           tindakan : tindakan,
           tarikh_mohon : item.tarikh_mohon,
           no_permohonan : item.no_permohonan,
           nama_premis : item.nama_premis,
           no_tel_premis : item.no_tel_premis,
           nama_pemohon : item.nama_pemohon,
           no_tel_pemohon : item.no_tel_pemohon,
           premis : item.premis,
       }
       this.getJuruteknik(item)
       this.dialog.show = true;
   },
   getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
        this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/2/0', {}).then(res => {
          this.juruteknik_list = res
        })
      }
    },
   capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
   },
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },

    getPremis(){
        this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
          this.premis = res
        })

   },
    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },
   tukarJuruteknik(tindakan, art_id){
      if(tindakan.catatan != null){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', art_id, tindakan)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan.tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else if (tindakan.tindakan==3) {
                    this.$zutil.notify("Berjaya ditukar", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.index'))
              })
            }
          }
        })
      }else{
        this.$zutil.notify("Catatan Wajib Diisi", false);
      }
      
   },
    onSuccess(tindakan, art_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', art_id, {tindakan :tindakan})
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.index'))
              })
            }
          }
        })
      
    },
    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   this.getArt();
   this.getTujuanPd();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
